class Autocomplete {

	constructor() {
		this.init();
	}

	init() {
    $(document).on('keyup', function(e){
      if(e.keyCode === 27 && $('#site-navigation.search-open').length){
        $('#navgiation-search, #site-navigation, #content, #breadcrumbs').toggleClass('search-open');
      }
    });

    $('#search').autocomplete({
    	serviceUrl: variables.ajax_url,
    	type: 'POST',
    	dataType: 'json',
    	paramName: 'term',
      noCache: true,
    	params: { action: function(){ return 'global_search'; } },
      showNoSuggestionNotice: true,
      noSuggestionNotice: '<div class="search-header-autocomplete-result no-icon">Inga resultat</div>',
    	minChars: 1,
      triggerSelectOnValidInput: false,
    	onSelect: function (suggestion) {
				jQuery('#search').val(suggestion.value.replace(/(<([^>]+)>)/ig,""));
      	jQuery('#search_form').submit();
    	},
    	formatResult: function (suggestion, currentValue) {
    		return '<div class="search-header-autocomplete-result">'+suggestion.value+'</div>';
    	},
    });
	}
}

export default Autocomplete;
